const dateFormat = new Intl.DateTimeFormat('de-CH', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

const timeFormat = new Intl.DateTimeFormat('de-CH', {
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
});

// in: JS date string, e.g. "2024-08-12T08:45:00+02:00"
// out: formatted date string, e.g. "23.02.2024"
export const formatDate = (date) => {
  return dateFormat.format(new Date(date));
};

// in: JS date string, e.g. "2024-08-12T08:45:00+02:00"
// out: formatted time string, e.g. "23:08"
export const formatTime = (date) => {
  return timeFormat.format(new Date(date));
};
